import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TransactionHistoryComponent } from 'src/app/Account/transaction-history/transaction-history.component';
import { AddAccountComponent } from 'src/app/AddThings/add-account/add-account.component';
import { ConstructAPI } from 'src/app/API/constructAPI';
import { RestApiService } from 'src/app/API/restapi';
import { ALERT_TYPE } from 'src/app/constants';
import { DeleteReasonComponent } from 'src/app/Others/delete-reason/delete-reason.component';
import { ConfirmationDialogComponent } from 'src/app/Shared/confirmation-dialog/confirmation-dialog.component';
import { Enums } from 'src/app/Shared/enums';
import { SharedService } from 'src/app/Shared/shared-service.service';
import { Account } from 'src/model/account.model';
import { Advance } from 'src/model/advance.modal';
import { Asset } from 'src/model/asset.model';
import { Commission } from 'src/model/commission.model';
import { VerifyAccountComponent } from '../verify-account/verify-account.component';

@Component({
	selector: 'app-list-hutang-report',
	templateUrl: './list-hutang-report.component.html',
	styleUrls: ['./list-hutang-report.component.scss'],
	standalone: false
})
export class ListHutangReportComponent implements OnInit {
	private activatedRoute = inject(ActivatedRoute);
	private restApi = inject(RestApiService);
	private constructApi = inject(ConstructAPI);
	protected enums = inject(Enums);
	private router = inject(Router);
	protected sharedService = inject(SharedService);

	routeSubscription: any;
	selectedCompany: number;
	endDate: Date;

	cashAccountList: Account[] = [];
	cashAccountBalance = 0;

	companyBankAccountList: Account[] = [];
	bankAccountBalance = 0;

	duitLebihBalance = 0;
	assetList: Asset[] = [];
	assetTotal = 0;

	advanceList: Advance[] = [];
	advanceTotal = 0;
	stampTotal = 0;
	stampHQTotal = 0;
	stampOfficeTotal = 0;
	legacyStampTotal = 0;
	scTotal = 0;
	hutangTotal = 0;
	simpanTotal = 0;
	commissionTotal = 0;
	commissionList: Commission[] = [];
	bdTotal = 0;
	handlingTotal = 0;
	cashBookAmount = 0;

	isCollapsed = false;
	showBalanceCollapse = true;
	showAdvanceCollapse = true;
	showCommissionCollapse = true;
	showStampCollapse = true;

	isVerified: boolean;
	isAdminVerified: boolean;
	verifiedUser: string;
	verifiedDate: Date;
	latestCheckInID: number;

	ngOnInit(): void {
		this.routeSubscription = this.activatedRoute.paramMap.subscribe(params => {
			this.selectedCompany = +params.get('companyId');
			// this.startDate = (params.get('startDate') == undefined) ? undefined : new Date(params.get('startDate'));
			this.endDate = params.get('endDate') == undefined ? undefined : new Date(params.get('endDate'));

			this.resetAllList();
			this.getCompanyTransactionBalances(this.selectedCompany);

			this.getAllAccountsOfCompany(this.selectedCompany);
			this.getAllHutang(this.selectedCompany);
			this.getAllUnpaidCommission(this.selectedCompany);
			// this.getAllUnpaidBadDebt(this.selectedCompany);
			this.getCashBookBalance(this.selectedCompany);
			this.getCheckInLatest(this.selectedCompany);
		});
	}

	resetAllList() {
		this.cashAccountBalance = 0;
		this.bankAccountBalance = 0;
		this.assetTotal = 0;
		this.advanceTotal = 0;
		this.hutangTotal = 0;
		this.simpanTotal = 0;
		this.scTotal = 0;
		this.stampTotal = 0;
		this.commissionTotal = 0;
		this.bdTotal = 0;
		this.cashBookAmount = 0;
		this.duitLebihBalance = 0;
		this.handlingTotal = 0;
		this.stampHQTotal = 0;
		this.stampOfficeTotal = 0;
		this.legacyStampTotal = 0;

		this.cashAccountList.splice(0, this.cashAccountList.length);
		this.companyBankAccountList.splice(0, this.companyBankAccountList.length);
		this.advanceList.splice(0, this.advanceList.length);
		this.assetList.splice(0, this.assetList.length);
		this.commissionList.splice(0, this.commissionList.length);
	}

	getCheckInLatest(companyId: number) {
		const addADayDate = new Date(Number(this.endDate) + 3600 * 1000 * 24 - 1);
		const date = addADayDate.toISOString();
		const xhttp = this.restApi.getRequest(this.constructApi.getCompaniesLatestCheckIns(companyId, date));
		xhttp.onreadystatechange = () => {
			if (xhttp.readyState == 4 && xhttp.status == 200) {
				const jsonArray = JSON.parse(xhttp.responseText);

				if (jsonArray.length == 0 || jsonArray == undefined) {
					this.isVerified = false;
					this.isAdminVerified = false;
				} else {
					jsonArray.forEach(json => {
						const compareDate = new Date(json.date).setHours(0, 0, 0, 0);
						const reportDate = new Date(this.endDate).setHours(0, 0, 0, 0);

						if (compareDate == reportDate) {
							this.isVerified = true;

							if (Number(json.roleId) == Number(this.enums.ADMIN)) this.isAdminVerified = true;
							else this.isAdminVerified = false;

							this.verifiedUser = json.username;
							this.verifiedDate = json.dateCreated;

							this.latestCheckInID = json.id;
						} else {
							this.isVerified = false;
							this.isAdminVerified = false;
						}
					});
				}
			}
		};
	}

	openDeleteReasonDialog() {
		const modalRef = this.sharedService.openModal(ConfirmationDialogComponent);
		modalRef.componentInstance.message = 'Confirm to delete checkin ?';

		modalRef.result.then(confirm => {
			if (confirm) {
				const modalRef = this.sharedService.openModal(DeleteReasonComponent);
				modalRef.componentInstance.passEntry.subscribe(entry => {
					const remark = entry;

					//append added account to account list
					this.deleteCheckIn(remark, this.latestCheckInID);
				});
			}
		});
	}

	deleteCheckIn(remark: string, checkInId: number) {
		const data = {
			reason: remark
		};

		const xhr = this.restApi.deleteRequest(this.constructApi.getDeleteCheckIn(this.selectedCompany, this.latestCheckInID), data);

		xhr.onreadystatechange = () => {
			if (xhr.readyState == 4) {
				if (xhr.readyState == 4 && xhr.status == 200) {
					if (xhr.status == 200) {
						window.location.reload();
					} else {
						this.sharedService.openAlert('Opps, some errors occured. Please try again later', ALERT_TYPE.DANGER);
					}
				}
			}
		};
	}

	checkCanVerify() {
		if (this.sharedService.isAdmin() || this.sharedService.isBossAccount()) {
			if (this.isAdminVerified == true) return false;
			else return true;
		} else if (this.sharedService.isBranchAccountHandler()) {
			if (this.isVerified == false) return true;
			else return false;
		}
	}

	toAdvanceList() {
		this.router.navigate(['/advanceList', this.selectedCompany]);
	}

	getAllAccountsOfCompany(companyId: number) {
		if (this.endDate != undefined)
			//in order to get the correct result, end date need to add 1 day and minus 1 millisecond
			// 3600*1000*24 is 1 day in millisecond, then reduced by 1 millisecond
			var addADayDate = new Date(Number(this.endDate) + 3600 * 1000 * 24 - 1);
		const endDateStr = this.endDate == undefined ? undefined : addADayDate.toISOString();

		const xhttp = this.restApi.getRequest(this.constructApi.getAccountsOfCompany(companyId, endDateStr));
		xhttp.onreadystatechange = () => {
			if (xhttp.readyState == 4 && xhttp.status == 200) {
				const jsonArray = JSON.parse(xhttp.responseText);

				jsonArray.forEach(json => {
					const amount = json.balance == undefined ? 0 : json.balance;
					const account = new Account(json.id, json.number, json.name, json.holderName, amount, json.companyId, json.username);

					if (account.Username != undefined) {
						this.cashAccountList.push(account);

						this.cashAccountBalance += amount;
					} else {
						this.companyBankAccountList.push(account);
						this.bankAccountBalance += amount;
					}
				});
			}
		};
	}

	getCashBookBalance(companyId: number) {
		if (this.endDate != undefined)
			//in order to get the correct result, end date need to add 1 day and minus 1 millisecond
			// 3600*1000*24 is 1 day in millisecond, then reduced by 1 millisecond
			var addADayDate = new Date(Number(this.endDate) + 3600 * 1000 * 24 - 1);
		const endDateStr = this.endDate == undefined ? undefined : addADayDate.toISOString();

		const xhttp = this.restApi.getRequest(this.constructApi.getCompanyCashBookBalance(companyId, endDateStr));
		xhttp.onreadystatechange = () => {
			if (xhttp.readyState == 4 && xhttp.status == 200) {
				const json = JSON.parse(xhttp.responseText);
				this.cashBookAmount = json.balance;
			}
		};
	}

	getCompanyTransactionBalances(companyId: number) {
		if (this.endDate != undefined)
			//in order to get the correct result, end date need to add 1 day and minus 1 millisecond
			// 3600*1000*24 is 1 day in millisecond, then reduced by 1 millisecond
			var addADayDate = new Date(Number(this.endDate) + 3600 * 1000 * 24 - 1);
		const endDateStr = this.endDate == undefined ? undefined : addADayDate.toISOString();

		const xhttp = this.restApi.getRequest(this.constructApi.getCompanyTransactionBalances(companyId, endDateStr));
		xhttp.onreadystatechange = () => {
			if (xhttp.readyState == 4 && xhttp.status == 200) {
				const jsonArray = JSON.parse(xhttp.responseText);
				jsonArray.forEach(json => {
					const type = Number(json.type);
					switch (type) {
						case this.enums.STAMP:
							this.legacyStampTotal += json.balance;
							this.stampTotal += json.balance;
							break;
						case this.enums.SERVICE_CHARGE:
							this.scTotal += json.balance;
							break;
						case this.enums.EXTRAS:
							this.duitLebihBalance += json.balance;
							break;
						case this.enums.ASSET:
							this.assetTotal += json.balance;
							break;
						case this.enums.RESERVE:
							this.simpanTotal += json.balance;
							break;
						case this.enums.ADVANCE:
							this.advanceTotal -= json.balance;
							break;
						case this.enums.BAD_DEBT:
							this.bdTotal += json.balance;
							break;
						case this.enums.HANDLING_CHARGE:
							this.handlingTotal += json.balance;
							break;
						case this.enums.STAMP_HQ:
							this.stampHQTotal += json.balance;
							this.stampTotal += json.balance;
							break;
						case this.enums.STAMP_OFFICE:
							this.stampOfficeTotal += json.balance;
							this.stampTotal += json.balance;
							break;
					}
				});
			}
		};
	}

	openTransactionHistoryModal(accountId: number) {
		const modalRef = this.sharedService.openModal(TransactionHistoryComponent, 'largeModal');
		modalRef.componentInstance.accountId = accountId;
		modalRef.componentInstance.selectedCompany = this.selectedCompany;
	}

	toReport(selectedReport) {
		//default the start data always the beginning of the month
		const startDate = new Date(this.endDate.getFullYear(), this.endDate.getMonth(), 1, 0, 0, 0, 0);
		const startDateStr = startDate.toISOString();

		if (this.endDate != undefined)
			//in order to get the correct result, end date need to add 1 day and minus 1 millisecond
			// 3600*1000*24 is 1 day in millisecond, then reduced by 1 millisecond
			var addADayDate = new Date(Number(this.endDate) + 3600 * 1000 * 24 - 1);
		const endDateStr = this.endDate == undefined ? undefined : addADayDate.toISOString();
		if (selectedReport != this.enums.EXTRA_REPORT) this.router.navigate(['/simpleReport', this.selectedCompany, selectedReport, startDateStr, endDateStr]);
		else this.router.navigate(['/duitLebihReport', this.selectedCompany, startDateStr, endDateStr]);
	}

	getAllHutang(companyId: number) {
		if (this.endDate != undefined)
			//in order to get the correct result, end date need to add 1 day and minus 1 millisecond
			// 3600*1000*24 is 1 day in millisecond, then reduced by 1 millisecond
			var addADayDate = new Date(Number(this.endDate) + 3600 * 1000 * 24 - 1);
		const endDateStr = this.endDate == undefined ? undefined : addADayDate.toISOString();

		const xhttp = this.restApi.getRequest(this.constructApi.getCompanyAllLoansTransactions(companyId, undefined, endDateStr, 'HUTANG', [this.enums.HUTANG]));
		xhttp.onreadystatechange = () => {
			if (xhttp.readyState == 4 && xhttp.status == 200) {
				const jsonArray = JSON.parse(xhttp.responseText);
				jsonArray.forEach(json => {
					this.hutangTotal += json.amount;
				});
			}
		};
	}

	getAllUnpaidCommission(companyId: number) {
		if (this.endDate != undefined)
			//in order to get the correct result, end date need to add 1 day and minus 1 millisecond
			// 3600*1000*24 is 1 day in millisecond, then reduced by 1 millisecond
			var addADayDate = new Date(Number(this.endDate) + 3600 * 1000 * 24 - 1);
		const endDateStr = this.endDate == undefined ? undefined : addADayDate.toISOString();

		const xhttp = this.restApi.getRequest(this.constructApi.getCompanyUnpaidCommission(companyId, endDateStr));
		xhttp.onreadystatechange = () => {
			if (xhttp.readyState == 4 && xhttp.status == 200) {
				const jsonArray = JSON.parse(xhttp.responseText);
				jsonArray.forEach(json => {
					const paid = json.paid == undefined ? 0 : Number(json.paid);
					this.commissionTotal += json.amount - paid;
					const commission = new Commission(
						json.id,
						json.loanId,
						json.amount,
						json.assignee,
						json.assignor,
						json.transactionId,
						json.dateCreated,
						undefined,
						json.customerName,
						json.principal
					);
					this.commissionList.push(commission);
				});
			}
		};
	}

	getAllUnpaidBadDebt(companyId: number) {
		if (this.endDate != undefined)
			//in order to get the correct result, end date need to add 1 day and minus 1 millisecond
			// 3600*1000*24 is 1 day in millisecond, then reduced by 1 millisecond
			var addADayDate = new Date(Number(this.endDate) + 3600 * 1000 * 24 - 1);
		const endDateStr = this.endDate == undefined ? undefined : addADayDate.toISOString();

		const xhttp = this.restApi.getRequest(this.constructApi.getCompanyUnpaidBadDebts(companyId, endDateStr));
		xhttp.onreadystatechange = () => {
			if (xhttp.readyState == 4 && xhttp.status == 200) {
				const jsonArray = JSON.parse(xhttp.responseText);
				jsonArray.forEach(json => {
					this.bdTotal += json.total;
				});
			}
		};
	}

	roundTo2Dec(num: number) {
		return Math.round(num * 100) / 100;
	}

	calculateListHutangTotal() {
		// return this.cashAccountBalance + this.bankAccountBalance + this.advanceTotal + (-this.hutangTotal) - this.assetTotal - this.duitLebihBalance - this.stampTotal -
		//   this.scTotal - this.simpanTotal - this.bdTotal - this.commissionTotal;
		return (
			this.cashAccountBalance +
			this.bankAccountBalance +
			this.advanceTotal +
			-this.hutangTotal -
			this.assetTotal -
			this.duitLebihBalance -
			this.stampTotal -
			this.scTotal -
			this.simpanTotal -
			this.bdTotal -
			this.handlingTotal
		);
	}

	openVerifyModal() {
		const modalRef = this.sharedService.openModal(VerifyAccountComponent, 'largeModal');
		modalRef.componentInstance.selectedCompany = this.selectedCompany;
		modalRef.componentInstance.endDate = this.endDate;
		modalRef.componentInstance.needStatusOutstanding = false;
	}

	openEditAccountModal(account: Account) {
		const modalRef = this.sharedService.openModal(AddAccountComponent);
		modalRef.componentInstance.accountId = account.ID;

		modalRef.componentInstance.accountNo = account.AccountNumber;
		modalRef.componentInstance.holderName = account.HolderName;
		modalRef.componentInstance.accountName = account.Name;
		modalRef.componentInstance.initialAmount = account.Balance;
		modalRef.componentInstance.isCashAccount = account.Username != undefined;
		modalRef.componentInstance.selectedCompanyID = account.CompanyId;
		modalRef.componentInstance.selectedUsername = account.Username;
	}

	confirmBeforeDeletingCommission(commission: Commission) {
		const modalRef = this.sharedService.openModal(ConfirmationDialogComponent);
		modalRef.componentInstance.message = 'Are you sure you want to delete the commission of ' + commission.Assignee + '- RM ' + commission.Amount + '?';

		modalRef.result.then(confirm => {
			if (confirm) this.deleteCommission(commission.LoanId, commission.ID);
		});
	}

	deleteCommission(loanId: number, commissionId: number) {
		const xhttp = this.restApi.deleteRequest(this.constructApi.getDeleteLoanCommission(loanId, commissionId));
		xhttp.onreadystatechange = () => {
			if (xhttp.readyState == 4 && xhttp.status == 200) {
				window.location.reload();
			}
		};
	}
}
